export default "__VITE_ASSET__BcwqcoxR__"